import {
  FileTextOutlined,
  UploadOutlined,
  UnorderedListOutlined,
} from '@ant-design/icons';
import { useFeatureEntitlements } from '@frontegg/react';
import { AppNavMenu } from '..';

export function useDocumentsAccess() {
  const { isEntitled } = useFeatureEntitlements('documents');
  const hasWorklistAccess = useFeatureEntitlements('documents-worklist');
  return {
    hasAccess: !!isEntitled,
    hasWorklistAccess,
  };
}

export const useDocumentsNavMenus = (): AppNavMenu[] => {
  const { hasAccess, hasWorklistAccess } = useDocumentsAccess();

  if (!hasAccess) {
    return [];
  }

  return [
    {
      path: '/documents',
      title: 'Docs',
      icon: <FileTextOutlined />,
      submenu: [
        ...(hasWorklistAccess
          ? [
              {
                path: '/documents/worklist',
                title: 'Worklist',
                icon: <UnorderedListOutlined />,
              },
            ]
          : []),
        {
          path: '/documents/bundles',
          title: 'Uploads',
          icon: <UploadOutlined />,
        },
      ],
    },
  ];
};
